/* HN_HYBRID_V13_PRINTED_QTY_TOTAL_JS */
(function () {
  function initHybridBuy(card) {
    if (!card || card.dataset.hnHybridBuyInitialized === 'true') return;
    card.dataset.hnHybridBuyInitialized = 'true';

    var form = card.querySelector('form[data-type="add-to-cart-form"]') || card.querySelector('form');
    var instantButton = card.querySelector('[data-hn-instant-button]');
    var addButton = card.querySelector('[name="add"]');
    var variantInput = card.querySelector('[data-hn-selected-variant-input]');
    var cards = card.querySelectorAll('[data-hn-variant-card]');
    var instantText = card.querySelector('[data-hn-instant-text]');
    var cartTooltip = card.querySelector('[data-hn-cart-tooltip]');
    var cartLabel = card.querySelector('[data-hn-cart-label]');
    var printedDetails = card.querySelector('[data-hn-printed-details]');
    var purchaseSummary = card.querySelector('[data-hn-purchase-summary]');
    var qtyInput = card.querySelector('[data-hn-quantity-input]');
    var qtyHidden = card.querySelector('[data-hn-quantity-hidden]');
    var qtyMinus = card.querySelector('[data-hn-qty-minus]');
    var qtyPlus = card.querySelector('[data-hn-qty-plus]');
    var totalPrice = card.querySelector('[data-hn-total-price]');
    var selectedPriceCents = 0;

    if (!form || !variantInput) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : root + 'cart/add.js';
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : root + 'cart';

    var copy = {
      digital: {
        instant: 'Buy Digital PDF',
        cart: 'Add Digital PDF to cart'
      },
      printed: {
        instant: 'Buy Printed Book',
        cart: 'Add Printed Book to cart'
      },
      book: {
        instant: 'Buy Now',
        cart: 'Add book to cart'
      }
    };


    var parsePositiveInteger = function (value) {
      var parsed = parseInt(value, 10);
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return parsed;
    };

    var getSelectedKind = function () {
      return card.getAttribute('data-selected-kind') || 'book';
    };

    var getQuantity = function () {
      if (getSelectedKind() !== 'printed') return 1;
      return parsePositiveInteger(qtyInput && qtyInput.value ? qtyInput.value : '1');
    };

    var formatMoney = function (cents) {
      var moneyFormat = card.getAttribute('data-money-format') || '${{amount}}';

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return '$' + (Number(cents || 0) / 100).toFixed(2);
    };

    var syncQuantity = function (nextValue) {
      var qty = parsePositiveInteger(nextValue);
      if (qtyInput) qtyInput.value = String(qty);
      if (qtyHidden) qtyHidden.value = String(getSelectedKind() === 'printed' ? qty : 1);
      if (totalPrice) totalPrice.innerHTML = formatMoney(selectedPriceCents * (getSelectedKind() === 'printed' ? qty : 1));
    };

    var getCartDrawer = function () {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    };

    var getSectionsFromDrawer = function (drawer) {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    };

    var setButtonLoading = function (button, isLoading) {
      if (!button) return;
      if (isLoading) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
      } else {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    };

    var showFormError = function (message) {
      var wrapper = card.querySelector('.product-form__error-message-wrapper');
      var errorMessage = card.querySelector('.product-form__error-message');
      if (!wrapper || !errorMessage) return;
      errorMessage.textContent = message || 'Unable to add this item to cart.';
      wrapper.removeAttribute('hidden');
    };

    var clearFormError = function () {
      var wrapper = card.querySelector('.product-form__error-message-wrapper');
      var errorMessage = card.querySelector('.product-form__error-message');
      if (!wrapper || !errorMessage) return;
      errorMessage.textContent = '';
      wrapper.setAttribute('hidden', '');
    };

    var updateButtonsDisabled = function (available) {
      var disabled = available !== true;
      if (addButton) addButton.disabled = disabled;
      if (instantButton) instantButton.disabled = disabled;
      if (variantInput) variantInput.disabled = false;
    };

    var setVariant = function (variantCard) {
      if (!variantCard || variantCard.getAttribute('aria-disabled') === 'true') return;

      var id = variantCard.getAttribute('data-variant-id');
      var kind = variantCard.getAttribute('data-variant-kind') || 'book';
      var priceCents = parseInt(variantCard.getAttribute('data-variant-price-cents') || '0', 10);
      var available = variantCard.getAttribute('data-variant-available') === 'true';
      var words = copy[kind] || copy.book;

      selectedPriceCents = Number.isFinite(priceCents) ? priceCents : 0;
      variantInput.value = String(id || '');
      variantInput.disabled = false;
      card.setAttribute('data-selected-kind', kind);
      if (printedDetails) printedDetails.hidden = kind !== 'printed';
      if (purchaseSummary) purchaseSummary.hidden = kind !== 'printed';
      syncQuantity(kind === 'printed' ? getQuantity() : 1);
      if (instantText) instantText.textContent = available ? words.instant : 'Currently unavailable';
      if (cartTooltip) cartTooltip.textContent = words.cart;
      if (cartLabel) cartLabel.textContent = words.cart;

      updateButtonsDisabled(available);

      cards.forEach(function (item) {
        var isSelected = item === variantCard;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
    };

    cards.forEach(function (variantCard) {
      variantCard.addEventListener('click', function () {
        setVariant(variantCard);
      });
    });


    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        syncQuantity(getQuantity() - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        syncQuantity(getQuantity() + 1);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        syncQuantity(qtyInput.value);
      });

      qtyInput.addEventListener('blur', function () {
        syncQuantity(qtyInput.value);
      });
    }

    var selectedCard = card.querySelector('[data-hn-variant-card].is-selected');
    if (selectedCard) {
      selectedPriceCents = parseInt(selectedCard.getAttribute('data-variant-price-cents') || '0', 10) || 0;
      syncQuantity(1);
    }

    var addToCart = function (options) {
      options = options || {};

      var button = options.button || addButton;
      var goToCheckout = options.goToCheckout === true;
      var drawer = getCartDrawer();
      var variantId = variantInput && variantInput.value ? String(variantInput.value) : null;

      if (!variantId) {
        showFormError('Please choose a book format first.');
        return;
      }

      clearFormError();
      setButtonLoading(button, true);

      var payload = {
        id: variantId,
        quantity: getSelectedKind() === 'printed' ? getQuantity() : 1
      };

      if (!goToCheckout) {
        payload.sections = getSectionsFromDrawer(drawer);
        payload.sections_url = window.location.pathname;
      }

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (parsedState) {
            if (!response.ok) throw parsedState;
            return parsedState;
          });
        })
        .then(function (parsedState) {
          if (goToCheckout) {
            window.location.href = root + 'checkout';
            return;
          }

          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(parsedState);
            setButtonLoading(button, false);
            return;
          }

          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
            setButtonLoading(button, false);
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: parsedState }
          }));

          window.location.href = cartUrl;
        })
        .catch(function (error) {
          var message = error && error.description ? error.description : 'Unable to add this item to cart.';
          showFormError(message);
          setButtonLoading(button, false);
        });
    };

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (addButton && addButton.hasAttribute('disabled')) return;

      addToCart({
        button: addButton,
        goToCheckout: false
      });
    }, true);

    if (instantButton) {
      instantButton.addEventListener('click', function () {
        if (instantButton.hasAttribute('disabled')) return;

        addToCart({
          button: instantButton,
          goToCheckout: true
        });
      });
    }
  }

  function initAllHybridBuyBlocks() {
    document.querySelectorAll('[data-hn-hybrid-buy]').forEach(initHybridBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHybridBuyBlocks);
  } else {
    initAllHybridBuyBlocks();
  }

  document.addEventListener('shopify:section:load', initAllHybridBuyBlocks);
})();
